import React from "react";
import { MentorshipOfferingCard } from "@/components/mentor/MentorshipOffering";
import { MentorshipOffering } from "@/services/mentorOfferingsService";
import { MentorRating } from "@/services/reviewService";
import { MentorshipListSkeleton } from "./MentorshipListSkeleton";

interface MentorshipListProps {
  mentorships: MentorshipOffering[];
  mentorRatings?: Record<string, MentorRating>;
  isLoading: boolean;
  error: Error | null;
  onCardClick: (mentorId: string, mentorSlug?: string | null) => void;
}

export const MentorshipList: React.FC<MentorshipListProps> = ({
  mentorships,
  mentorRatings = {},
  isLoading,
  error,
  onCardClick,
}) => {
  if (isLoading) {
    return <MentorshipListSkeleton />;
  }

  if (error) {
    console.error("Error in MentorshipList:", error);
    return (
      <div className="text-center w-full py-12">
        <span className="text-red-500 text-lg">Erro ao carregar mentorias: {error.message}</span>
        <p className="text-gray-400 mt-2">Tente novamente mais tarde.</p>
      </div>
    );
  }

  if (!mentorships || mentorships.length === 0) {
    console.log("No mentorships to display in MentorshipList component");
    return (
      <div className="text-center w-full py-12">
        <span className="text-white text-lg">Nenhuma mentoria encontrada.</span>
        <p className="text-gray-400 mt-2">Tente outros filtros de busca ou verifique mais tarde.</p>
      </div>
    );
  }

  console.log(`Rendering ${mentorships.length} mentorship cards in MentorshipList`);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {mentorships.map((mentorship) => {
        console.log(`Rendering card for mentorship: ${mentorship.id}, mentor: ${mentorship.mentor_id || 'unknown'}, mentor_name: ${mentorship.mentor_name || 'unnamed'}`);
        
        // Para a página /mentorias, vamos passar um card customizado com rating
        // ao invés de usar o MentorshipOfferingCard (que já busca rating internamente)
        return (
          <MentorshipOfferingCard
            key={mentorship.id}
            id={mentorship.id}
            title={mentorship.title}
            description={mentorship.description}
            price={mentorship.price_cents}
            duration={mentorship.duration_minutes}
            game={mentorship.game}
            coverImageUrl={mentorship.cover_image_url}
            isActive={mentorship.is_active}
            isGroup={mentorship.is_group}
            maxParticipants={mentorship.max_participants}
            mentorName={mentorship.mentor_name}
            mentorImageUrl={mentorship.mentor_image_url}
            mentorId={mentorship.mentor_id}
            onCardClick={() => {
              console.log(`Card clicked for mentor: ${mentorship.mentor_id}`);
              if (mentorship.mentor_id) {
                onCardClick(mentorship.mentor_id, mentorship.mentor_slug);
              }
            }}
          />
        );
      })}
    </div>
  );
};
